import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const data = [{
  month: 'Jan',
  avgBloodPressure: 120,
  avgBloodSugar: 95,
  avgHeartRate: 72
}, {
  month: 'Feb',
  avgBloodPressure: 118,
  avgBloodSugar: 92,
  avgHeartRate: 74
}, {
  month: 'Mar',
  avgBloodPressure: 121,
  avgBloodSugar: 94,
  avgHeartRate: 73
}, {
  month: 'Apr',
  avgBloodPressure: 119,
  avgBloodSugar: 90,
  avgHeartRate: 71
}, {
  month: 'May',
  avgBloodPressure: 117,
  avgBloodSugar: 88,
  avgHeartRate: 70
}, {
  month: 'Jun',
  avgBloodPressure: 122,
  avgBloodSugar: 91,
  avgHeartRate: 72
}];
export const HealthMetricsChart: React.FC = () => {
  return <ResponsiveContainer width="100%" height="100%" data-id="element-27">
      <LineChart data={data} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-28">
        <CartesianGrid strokeDasharray="3 3" data-id="element-29" />
        <XAxis dataKey="month" data-id="element-30" />
        <YAxis data-id="element-31" />
        <Tooltip data-id="element-32" />
        <Legend data-id="element-33" />
        <Line type="monotone" dataKey="avgBloodPressure" stroke="#255db7" activeDot={{
        r: 8
      }} data-id="element-34" />
        <Line type="monotone" dataKey="avgBloodSugar" stroke="#f97c6b" data-id="element-35" />
        <Line type="monotone" dataKey="avgHeartRate" stroke="#f6d052" data-id="element-36" />
      </LineChart>
    </ResponsiveContainer>;
};